(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('PeeringDialogController', PeeringDialogController);

    PeeringDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Peering', 'DbhawkPeeringService', 'Region'];

    function PeeringDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Peering, DbhawkPeeringService, Region) {
        var vm = this;

        vm.peering = entity;

        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        Region.query(function(result) {
            vm.regions = result;
            vm.peering.region = vm.regions[0];
        });

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            DbhawkPeeringService.createPeering(vm.peering, vm.peering.instanceId).then(function(response) {
                vm.success = 'OK';
                $uibModalInstance.close(true);
            })
                .catch(function(response) {
                    vm.isSaving = false;
                    vm.error = 'ERROR';
            });

        }

        function onSaveSuccess (result) {
            $scope.$emit('cloudApp:peeringUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.created = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
